import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from 'react-router-dom';
import {
	XNavbar,
	XSpace,
	XDropdown,
	XAvatar,
	XDownOutlined,
	XUpdateModal,
} from './HeaderStyle';
import { MenuOutlined, CloseOutlined } from '@ant-design/icons';
import { XContainer } from '../../styles/GlobalThemeStyleCQ';
// actions
import { logoutApi, logoutReset } from '../../actions/logoutAction';
import { Col, notification, Row, Skeleton } from 'antd';
import config from '../../config';
import {
	checkModulePermissions,
	getFirstAvailableRoute,
	getUserProfile,
	getUserRole,
} from '../../utils/helper';
import { SoundOutlined } from '@ant-design/icons';
import {
	getCodeUpdateDatesApi,
	getCodeUpdateDatesReset,
} from '../../actions/getCodeUpdateDatesAction';
import moment from 'moment';
import { NavDropdown } from 'react-bootstrap';

const HeaderFile = (props) => {
	const {
		logout,
		logoutReset,
		logoutState,
		getCodeUpdateDates,
		getCodeUpdateDatesState,
		getCodeUpdateDatesReset,
	} = props;
	const navigate = useNavigate();
	const [hamberToggle, setHamberToggle] = useState(false);
	const [previousPath, setPreviousPath] = useState(null); // Store previous path
	const location = useLocation();
	const [updatedDatesModal, setUpdatedDatesModal] = useState(false);
	const [datesLoading, setDatesLoading] = useState(false);
	const [updatedDates, setUpdatedDates] = useState('');

	const toggleHamburger = () => {
		setHamberToggle(!hamberToggle);
	};

	const items = [
		{
			key: '1',
			label: <Link to="/profile">My Profile</Link>,
			icon: (
				<img
					className="img-fluid"
					src="/images/profile-icon.svg"
					alt=""
				/>
			),
		},
		{
			type: 'divider',
		},
		localStorage.getItem('role') === 'super-admin' && {
			key: '2',
			label: (
				<Link
					onClick={() => {
						setUpdatedDatesModal(true);
						getCodeUpdateDates(); // Fetch the update dates when the link is clicked
					}}
				>
					Policies and Codes Updated at
				</Link>
			),
			icon: <SoundOutlined style={{ fontSize: '1rem' }} />,
		},
		localStorage.getItem('role') === 'super-admin' && { type: 'divider' }, // Optional divider
		{
			key: '3',
			label: <Link to="/change-password">Reset Password</Link>,
			icon: <img className="img-fluid" src="/images/reset.svg" alt="" />,
		},
		{
			type: 'divider',
		},
		{
			key: '4',
			label: (
				<Link
					onClick={() => {
						console.log('loks');
						logout();
					}}
				>
					Log Out
				</Link>
			),
			icon: <img className="img-fluid" src="/images/logout.svg" alt="" />,
		},
	];

	// Store the current path before it changes
	useEffect(() => {
		setPreviousPath(location.pathname);
	}, [location]);

	// use effect
	useEffect(() => {
		if (logoutState.apiState === 'success') {
			localStorage.removeItem('accessToken');
			localStorage.removeItem('email');
			localStorage.removeItem('username');
			localStorage.removeItem('refreshToken');
			localStorage.removeItem('expiresAt');
			localStorage.removeItem('changePassword');
			localStorage.removeItem('profile');
			localStorage.removeItem('permissions');
			localStorage.removeItem('role');
			localStorage.removeItem('fcmToken');
			localStorage.removeItem('unlock_llm_configuration_tab');
			logoutReset();
			navigate('/login');
		} else if (logoutState.apiState === 'error') {
			notification.error({ message: logoutState.message });
			logoutReset();
		}
	}, [logoutState]);

	// use effect
	useEffect(() => {
		if (logoutState.apiState === 'success') {
			localStorage.removeItem('accessToken');
			localStorage.removeItem('username');
			localStorage.removeItem('refreshToken');
			localStorage.removeItem('expiresAt');
			localStorage.removeItem('profile');
			localStorage.removeItem('permissions');
			localStorage.removeItem('fcmToken');
			localStorage.removeItem('unlock_llm_configuration_tab');
			logoutReset();
			navigate('/login');
		} else if (logoutState.apiState === 'error') {
			notification.error({ message: logoutState.message });
			logoutReset();
		}
	}, [logoutState]);

	useEffect(() => {
		if (getCodeUpdateDatesState.apiState === 'loading') {
			setDatesLoading(true);
		}
		if (getCodeUpdateDatesState.apiState === 'success') {
			setDatesLoading(false);
			setUpdatedDates(getCodeUpdateDatesState.data);
		}
		if (getCodeUpdateDatesState.apiState === 'error') {
			setDatesLoading(false);
			notification.error({ message: getCodeUpdateDatesState.message });
		}
		getCodeUpdateDatesReset();
	}, [getCodeUpdateDatesState]);

	// Check permissions for various modules
	const dashboardPermission = checkModulePermissions('dashboard').authorized;
	const caseManagementPermission =
		checkModulePermissions('case-management').authorized;
	const caseFilingPermission =
		checkModulePermissions('case-filing').authorized;
	const batchesPermission = checkModulePermissions('batch').authorized;
	const openAnalysisPermission =
		checkModulePermissions('open-analysis').authorized;
	const aipaPermission = checkModulePermissions('aipa').authorized;
	const caseAnalysisPermission =
		checkModulePermissions('case-analysis').authorized;
	const maPlanPermission = checkModulePermissions(
		'ma-plan-appeals-processing',
	).authorized;
	const caseClosurePermission =
		checkModulePermissions('case-closure').authorized;
	const voiceAssistancePermission =
		checkModulePermissions('voice-assistance').authorized;
	const codingTeamPermission =
		checkModulePermissions('coding-team').authorized;
	const mdAdvisorPermission = checkModulePermissions('md-advisor').authorized;
	const appealLetterAssignmentPermission = checkModulePermissions(
		'appeal-letter-assignment',
	).authorized;
	const feedbackPermission =
		checkModulePermissions('feedback-analysis').authorized;
	const appealLetterPermission =
		checkModulePermissions('appeal-letter').authorized;

	// Configuration section permissions
	const userRolePermission =
		checkModulePermissions('user-management').authorized;
	const insuranceCompanyPermission = checkModulePermissions(
		'insurance-company-management',
	).authorized;
	const hospitalPermission = checkModulePermissions(
		'hospital-management',
	).authorized;
	const regionsPermission =
		checkModulePermissions('region-management').authorized;
	const organizationPermission = checkModulePermissions(
		'organization-management',
	).authorized;
	const payerConfigPermission = checkModulePermissions(
		'payer-configuration',
	).authorized;
	const reimbursementsPermission =
		checkModulePermissions('reimbursements').authorized;
	const notificationPermission = getUserRole() === 'super-admin';

	// Check if Case Analytics section should be shown
	const showCaseAnalyticsSection =
		caseManagementPermission ||
		caseFilingPermission ||
		openAnalysisPermission ||
		aipaPermission ||
		caseAnalysisPermission ||
		maPlanPermission ||
		batchesPermission ||
		voiceAssistancePermission;

	// Check if Other Resources section should be shown
	const showOtherResourcesSection =
		codingTeamPermission ||
		mdAdvisorPermission ||
		appealLetterAssignmentPermission ||
		caseClosurePermission ||
		feedbackPermission ||
		appealLetterPermission;

	// Check if Configuration section should be shown
	const showConfigurationSection =
		insuranceCompanyPermission ||
		hospitalPermission ||
		regionsPermission ||
		organizationPermission ||
		payerConfigPermission ||
		reimbursementsPermission ||
		notificationPermission ||
		userRolePermission;

	return (
		<>
			<XNavbar expand={'xl'} className="mb-3">
				<XContainer fluid>
					<Navbar.Brand
						href={
							checkModulePermissions('dashboard').authorized ||
							checkModulePermissions('nano-dashboard').authorized
								? '/'
								: getFirstAvailableRoute()?.path || '/'
						}
					>
						<span className="logo">
							<img
								style={{ height: 30 }}
								src="/images/reclaim_short_logo.svg"
								alt="logo"
							/>
						</span>
					</Navbar.Brand>

					<Navbar.Toggle
						onClick={toggleHamburger}
						// aria-controls={`offcanvasNavbar-expand-xl`}
					>
						{hamberToggle ? <CloseOutlined /> : <MenuOutlined />}
					</Navbar.Toggle>

					<Navbar.Offcanvas
						id={`offcanvasNavbar-expand-xl`}
						aria-labelledby={`offcanvasNavbarLabel-expand-xl`}
						placement="top"
						visible="true"
					>
						<Offcanvas.Body>
							<Nav className="justify-content-center centerMenuSpace flex-grow-1">
								{/* Dashboard Link */}
								{dashboardPermission && (
									<Link
										to={'/'}
										className={
											location.pathname === '/'
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Dashboard
									</Link>
								)}

								{/* Case Analytics Section Title */}
								{showCaseAnalyticsSection && (
									<div className="sidebarTitle">
										Case Analytics
									</div>
								)}

								{/* Case Management Dropdown */}
								{caseManagementPermission && (
									<NavDropdown
										title="Case Management"
										id="caseManagementSubMenu"
										className="caseManagementSubMenu"
									>
										{caseManagementPermission && (
											<NavDropdown.Item
												as={Link}
												to="/case-management"
											>
												Case Details
											</NavDropdown.Item>
										)}
										{caseAnalysisPermission && (
											<NavDropdown.Item
												as={Link}
												to="/case-analysis"
											>
												Case Analysis
											</NavDropdown.Item>
										)}
										{caseFilingPermission && (
											<NavDropdown.Item
												as={Link}
												to="/case-filing-management"
											>
												Case Filing
											</NavDropdown.Item>
										)}
										{maPlanPermission && (
											<NavDropdown.Item
												as={Link}
												to="/standard-appeal-tat"
											>
												MA Plan Appeals
											</NavDropdown.Item>
										)}
									</NavDropdown>
								)}

								{/* Voice Assistance Link */}
								{batchesPermission &&
									(location.pathname === '/agent-maxx' ||
									location.pathname.startsWith(
										'/agent-maxx/',
									) ||
									location.search ? (
										<a href="/agent-maxx">Agent Maxx</a>
									) : (
										<>
											<Link
												to={'/agent-maxx'}
												className={
													location.pathname ===
													'/agent-maxx'
														? 'nav-link active'
														: 'nav-link'
												}
											>
												Agent Maxx
												{/* <span className="newBadge">New</span> */}
											</Link>
										</>
									))}
								<Link
									to={'/call-insurance'}
									className={
										location.pathname === '/call-insurance'
											? 'nav-link active'
											: 'nav-link'
									}
								>
									Call Maxx
								</Link>
								{/* {batchesPermission && (
									<Link
										to={'/agent-maxx'}
										className={
											location.pathname === '/agent-maxx'
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Case Agent
									</Link>
								)} */}
								{/* Batches changed to Agent Maxx Link */}
								{batchesPermission && (
									<Link
										to={'/maxx-v1'}
										className={
											location.pathname === '/maxx-v1'
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Maxx v1
									</Link>
								)}

								{/* Open Analysis Link */}
								{openAnalysisPermission && (
									<>
										{previousPath === '/open-analysis' ? (
											<a
												href="/open-analysis"
												className={
													location.pathname ===
													'/open-analysis'
														? 'nav-link active'
														: 'nav-link'
												}
											>
												Open Analysis
											</a>
										) : (
											<Link
												to={'/open-analysis'}
												className={
													location.pathname ===
													'/open-analysis'
														? 'nav-link active'
														: 'nav-link'
												}
											>
												Open Analysis
											</Link>
										)}
									</>
								)}
								{/* AIPA Link */}
								{aipaPermission && (
									<>
										{previousPath === '/aipa' ? (
											<a
												href="/aipa"
												className={
													location.pathname ===
													'/aipa'
														? 'nav-link active'
														: 'nav-link'
												}
											>
												AIPA
											</a>
										) : (
											<Link
												to={'/aipa'}
												className={
													location.pathname ===
													'/aipa'
														? 'nav-link active'
														: 'nav-link'
												}
											>
												AIPA
											</Link>
										)}
									</>
								)}

								<Link
									to={'/shield-maxx'}
									className={
										location.pathname === '/shield-maxx'
											? 'nav-link active'
											: 'nav-link'
									}
								>
									Shield Maxx
								</Link>
								

								{/* Configurations Section Title */}
								{showConfigurationSection && (
									<div className="sidebarTitle">
										CONFIGURATIONS
									</div>
								)}
								{/* User & Role Management Link */}
								{userRolePermission && (
									<Link
										to={'/user-role-management'}
										className={
											location.pathname ===
												'/user-role-management' ||
											location.pathname.startsWith(
												'/user-role-management/',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										User & Role Management
									</Link>
								)}
								{/* Insurance Company Link */}
								{insuranceCompanyPermission && (
									<Link
										to={'/insurance-company'}
										className={
											location.pathname.startsWith(
												'/insurance-company',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Insurance Company
									</Link>
								)}
								{/* Hospital Link */}
								{hospitalPermission && (
									<Link
										to={'/hospital'}
										className={
											location.pathname.startsWith(
												'/hospital',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Hospitals
									</Link>
								)}
								{/* Regions Link */}
								{regionsPermission && (
									<Link
										to={'/regions'}
										className={
											location.pathname.startsWith(
												'/regions',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Regions
									</Link>
								)}
								{/* Organizations Link */}
								{organizationPermission && (
									<Link
										to={'/organization'}
										className={
											location.pathname.startsWith(
												'/organization',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Organizations
									</Link>
								)}
								{/* Payer Configuration Link */}
								{payerConfigPermission && (
									<Link
										to={'/payer-configuration'}
										className={
											location.pathname.startsWith(
												'/payer-configuration',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Payer Configuration
									</Link>
								)}

								{/* Reimbursements Link */}
								{reimbursementsPermission && (
									<Link
										to={'/reimbursements'}
										className={
											location.pathname.startsWith(
												'/reimbursements',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Reimbursements
									</Link>
								)}

								{/* Notifications Management Link */}
								{notificationPermission && (
									<Link
										to={'/notification-management'}
										className={
											location.pathname.startsWith(
												'/notification-management',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Notifications Management
									</Link>
								)}

								{/* Other Resources Section Title */}
								{showOtherResourcesSection && (
									<div className="sidebarTitle">
										OTHER resources
									</div>
								)}

								{/* Coding Team Link */}
								{codingTeamPermission && (
									<Link
										to={'/coding-team'}
										className={
											location.pathname.startsWith(
												'/coding-team',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Coding Team
									</Link>
								)}

								{/* MD Advisor Link */}
								{mdAdvisorPermission && (
									<Link
										to={'/md-advisor'}
										className={
											location.pathname.startsWith(
												'/md-advisor',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										MD Advisor
									</Link>
								)}

								{/* Appeal Letter Assignment Link */}
								{appealLetterAssignmentPermission && (
									<Link
										to={'/appeal-letter-assignment'}
										className={
											location.pathname.startsWith(
												'/appeal-letter-assignment',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Assign Appeal Letter
									</Link>
								)}

								{/* //Todo Not in use */}
								{/* Case Closure Link */}
								{/* {caseClosurePermission && (
									<Link
										to={'/case-closure'}
										className={
											location.pathname.startsWith(
												'/case-closure',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Case Closure
									</Link>
								)} */}

								{/* //Todo Not in use */}
								{/* Feedback Link */}
								{/* {feedbackPermission && (
									<Link
										to={'/feedback'}
										className={
											location.pathname.startsWith(
												'/feedback',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Feedback
									</Link>
								)} */}

								{/* //Todo Not in use */}
								{/* Appeal Letter Link */}
								{/* {appealLetterPermission && (
									<Link
										to={'/appeal-letter'}
										className={
											location.pathname.startsWith(
												'/appeal-letter',
											)
												? 'nav-link active'
												: 'nav-link'
										}
									>
										Appeal Letter
									</Link>
								)} */}
							</Nav>
							<Nav className="justify-content-end flex-grow-2">
								<XDropdown
									menu={{
										items,
									}}
									// placement="bottom"
								>
									<XSpace>
										<XAvatar
											size={30}
											src={
												getUserProfile() === 'undefined'
													? '/images/prifile.svg'
													: `${
															config.s3_url
													  }${getUserProfile()}`
											}
										/>
										<XDownOutlined />
									</XSpace>
								</XDropdown>
							</Nav>
						</Offcanvas.Body>
					</Navbar.Offcanvas>
				</XContainer>
			</XNavbar>

			<XUpdateModal
				title="Policies and Codes Updated at"
				centered
				open={updatedDatesModal}
				onCancel={() => {
					setUpdatedDatesModal(false);
					getCodeUpdateDatesReset(); // Reset the state when modal is closed
					setUpdatedDates('');
				}}
				width={650}
				footer={false}
			>
				<Row gutter={(15, 15)}>
					{datesLoading && (
						<Col span={24} style={{ textAlign: 'center' }}>
							<Skeleton active paragraph={{ rows: 3 }} />
						</Col>
					)}
					{updatedDates &&
						updatedDates.map((item) => (
							<Col
								xs={24}
								sm={12}
								md={12}
								lg={12}
								className="my-2"
								key={item._id}
							>
								<div className="modalCard">
									<Row
										gutter={(15, 15)}
										className="align-items-center"
									>
										<Col xs={6}>
											<div className="cardImgBg">
												<img
													src="/images/policies-ncd-icon.svg"
													alt=""
												/>
											</div>
										</Col>
										<Col xs={18}>
											<h4
												style={{
													color: '#212226',
													fontWeight: '600',
												}}
											>
												{item.code_type}
											</h4>
											<h6>
												{(item.code_type === 'ICD' &&
													item.update_name) ||
												(item.code_type === 'CPT' &&
													item.update_name) ? (
													<>
														Version -{' '}
														{item.update_name}
													</>
												) : (
													<>
														Released On -{' '}
														{moment(
															item.latest_update
																.date,
														).format('DD MMM YYYY')}
													</>
												)}
											</h6>
											<h6 style={{ fontStyle: '' }}>
												Last Checked Date -{' '}
												{moment(item.updatedAt).format(
													'DD MMM YYYY',
												)}
											</h6>
										</Col>
									</Row>
								</div>
							</Col>
						))}
				</Row>
			</XUpdateModal>
		</>
	);
};

const mapStateToProps = (state) => ({
	logoutState: state.logout,
	getCodeUpdateDatesState: state.getCodeUpdateDates,
});

const mapDispatchToProps = (dispatch) => ({
	logout: (params) => dispatch(logoutApi(params)),
	logoutReset: () => dispatch(logoutReset()),
	getCodeUpdateDates: () => dispatch(getCodeUpdateDatesApi()),
	getCodeUpdateDatesReset: () => dispatch(getCodeUpdateDatesReset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderFile);
